import { ProjectType } from '@/types/data'
import React, { HTMLAttributes } from 'react'

type Props = HTMLAttributes<HTMLAnchorElement> & {
    project: ProjectType
    index: number
}

const ProjectCard = ({ project, index, ...props }: Props) => {
  return (
    <a
        href={project.href}
        target='_blank'
        style={{
            animation: `fadeIn ${index}s ease forwards`,
            animationDelay: `${index * 0.2}s`
        }}
        {...props} className='
        p-4 border flex flex-col gap-y-2 
        border-blue-500/25 rounded-lg 
        cursor-pointer hover:border-blue-500
        transition-all divide-gray-200
        '>
        <img src={project.cover} alt='project cover' className='w-auto max-sm:h-[150px] h-[250px] rounded-lg' />
        <div className='flex flex-col gap-y-2'>
            <h1 className='font-bold text-blue-500 text-xl text-center'>{project.name}</h1>
            <p className='indent-14 text-sm'>{project.desc}</p>
            <div className='flex justify-between items-center'>
                <div className='flex gap-x-2'>
                    {
                        project.technologies.map((icon, idx: number) => (
                            <span key={idx} className='p-1 border hover:-translate-y-1 border-blue-500 rounded-full'>{icon}</span>
                        ))
                    }
                </div>
                <span className='bg-blue-500 p-2 text-xs rounded-2xl font-bold'>{project.type}</span>
            </div>
        </div>

    </a>
  )
}

export default ProjectCard